import type { EventType } from '@cocoonspace/sdk-js/v2/types/eventType'
import { useCallback } from 'react'
import { useGetMeProfile } from '@cocoonspace/sdk-js/v2/domains/me-profile/me-profile'
import { useCopyClipboard } from '@cocoonspace/shared/hooks/use-copy-clipboard.hook'
import { useLingui } from '@lingui/react/macro'
import { LinkIcon } from 'lucide-react'
import { toast } from 'sonner'

import { ScheduleCardActionBtn } from '../../scheduling-card'

export const CopyLinkAction = ({ eventType }: { eventType: EventType }) => {
	const { t } = useLingui()
	const { copyToClipboard } = useCopyClipboard()
	const { data: meProfile } = useGetMeProfile()

	const copyUrl = useCallback(() => {
		const origin = window.location.origin
		const isPublic = meProfile?.eventTypeIds?.includes(eventType.id)
		const userSlug = meProfile?.slug
		const eventTypeId = eventType.id

		const url = isPublic
			? `${origin}/${userSlug}/${eventTypeId}`
			: `${origin}/scheduling/${eventTypeId}`

		return copyToClipboard(url).then(() => {
			toast.success(t`URL copiée`)
		})
	}, [
		copyToClipboard,
		eventType.id,
		t,
		meProfile?.slug,
		meProfile?.eventTypeIds,
	])

	return (
		<ScheduleCardActionBtn
			title={t`Copier l'URL`}
			onClick={copyUrl}
		>
			<LinkIcon />
		</ScheduleCardActionBtn>
	)
}
